export enum PREVENT_CHARACTER {
  NUMBER,
  LETTER,
  SPECIAL_CHAR,
  SPECIAL_CHAR_EXCEPT_PLUS,
}

export class PreventCharacterHelper {
  /**
   * Removes several categories of characters from an input's current value.
   * @param event The keyboard event triggered on the input
   * @param characters Categories of characters to remove
   * @return The input's value with the disallowed characters removed
   */
  public static preventMultiple(event: KeyboardEvent, characters: PREVENT_CHARACTER[]): string {
    let value = (event.target as HTMLInputElement).value;
    characters.forEach((c) => {
      switch (c) {
        case PREVENT_CHARACTER.NUMBER:
          value = this.noNumber(value);
          break;
        case PREVENT_CHARACTER.LETTER:
          value = this.noLetter(value);
          break;
        case PREVENT_CHARACTER.SPECIAL_CHAR:
          value = this.noSpecialChar(value);
          break;
        case PREVENT_CHARACTER.SPECIAL_CHAR_EXCEPT_PLUS:
          value = this.noSpecialCharExceptPlus(value);
          break;
      }
    });
    return value;
  }

  /**
   * Removes digits from the given value.
   * @param value The value to strip
   * @return The value without any digit
   */
  public static noNumber(value: string): string {
    return value.replace(/[0-9]/g, "");
  }

  /**
   * Removes letters, hyphens, spaces and apostrophes from the given value.
   * @param value The value to strip
   * @return The value without any letter, hyphen, space or apostrophe
   */
  public static noLetter(value: string): string {
    return value.replace(/[A-Za-z- ']/g, "");
  }

  /**
   * Removes any character that is not a letter or a digit from the given value.
   * @param value The value to strip
   * @return The value containing only letters and digits
   */
  public static noSpecialChar(value: string): string {
    return value.replace(/[^a-zA-Z0-9]/g, "");
  }

  /**
   * Removes any character that is not a letter, a digit or a plus sign from the given value.
   * @param value The value to strip
   * @return The value containing only letters, digits and plus signs
   */
  public static noSpecialCharExceptPlus(value: string): string {
    return value.replace(/[^a-zA-Z0-9+]/g, "");
  }
}
